// Special Orders App Index
// Routes to the appropriate Special Orders page based on the URL

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import Dashboard from './Dashboard';
import OrderForm from './OrderForm';

const SpecialOrdersApp = () => {
  return (
    <Routes>
      {/* Main dashboard */}
      <Route
        path="/"
        element={
          <ProtectedRoute requiredPermission="special-orders:read">
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* Create new order */}
      <Route
        path="/create"
        element={
          <ProtectedRoute requiredPermission="special-orders:write">
            <OrderForm />
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/special-orders" replace />} />
    </Routes>
  );
};

export default SpecialOrdersApp;
